const REPORTS_LABEL = [
  'Volunteer Hours',
  'PENCIL Positives',
  'Gratitude',
  'Donation',
]

const COLOR_CLASS = [
  'bg-blue-light',
  'bg-green-300',
  'bg-indigo-300',
  'bg-purple-300',
  'bg-pink-300',
  'bg-orange-300',
  'bg-teal-300',
]

export { REPORTS_LABEL, COLOR_CLASS }
